import styled from 'styled-components';
import { Divider } from 'antd';

export const BannerContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  max-width: 1200px;
  align-self: center;
  flex-direction: column;
`;

export const BannerSection = styled.div`
  position: relative;
  width: 100%;
  height: 197px;
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ThumbnailWrapper = styled.div`
  position: absolute;
  bottom: -32px;
  width: 128px;
  height: 128px;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;

  @media (max-width: 600px) {
    left: 50%;
    transform: translateX(-50%);
  }

  @media (min-width: 601px) {
    left: 24px;
    transform: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ContentSection = styled.div`
  padding: 48px 24px 24px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  
  @media (min-width: 600px) {
    display: flex;
    gap: 2rem;
  }

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const TitleDescriptionGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme?.colors?.text?.headings};

  font-size: 24px;
  font-weight: 700;
  align-self: left;
  text-align: left;
`;

export const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;
  margin: 16px 0;
  width: 100%;
`;

export const TabButton = styled.button<{ active: boolean }>`
  background: none;
  border: none;
  padding: 8px 4px;
  color: ${({ active, theme }) => active ? theme?.colors?.text?.paragraphs : theme?.colors?.text?.headings};
  font-size: 14px;
  font-weight: ${({ active }) => active ? '700' : '400'};
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;

  &:after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${({ active, theme }) => active ? theme?.colors?.theme?.brandColor3 : 'transparent'};
    transition: all 0.3s ease;
  }

  &:hover {
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  }
`;

export const StyledDivider = styled(Divider)`
  margin: 16px 0;
  border-color: rgba(255, 255, 255, 0.1);
`;

export const Description = styled.p`
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  font-size: 1rem;
  text-align: left;
  font-weight: 400;
`;
